import { ImageIcon } from 'components/icons/ImageIcon';
import { SummaryIcon } from 'components/icons/SummaryIcon';
import { Share2Icon } from 'components/icons/ShareIcon2';
import { ThumbUpIcon } from 'components/icons/ThumbUpIcon';
import { FolderIcon } from 'components/icons/FolderIcon';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';

export const ExternalTabConfig = [
  {
    key: 'Feedback',
    label: 'Feedback',
    icon: (selected: any) => (
      <ThumbUpIcon className={`w-6 h-6 ${selected ? 'fill-gray-icon' : 'stroke-gray-icon group-hover:stroke-black'}`} />
    )
  },
  {
    key: 'Resources',
    label: 'Resources',
    icon: (selected: any) => (
      <FolderIcon className={`w-6 h-6 ${selected ? 'fill-black' : 'fill-gray-icon group-hover:fill-black'}`} />
    )
  },
  {
    key: 'Summary',
    label: 'Summary',
    icon: (selected: any) => (
      <SummaryIcon className={`w-6 h-6 ${selected ? 'fill-black' : 'fill-gray-icon group-hover:fill-black'}`} />
    )
  },
  {
    key: 'Thumbnails',
    label: 'Thumbnails',
    icon: (selected: any) => (
      <ImageIcon className={`w-6 h-6 ${selected ? 'fill-black' : 'fill-gray-icon group-hover:fill-black'}`} />
    )
  },
  {
    key: 'Share',
    label: 'Share',
    icon: (selected: any) => (
      <Share2Icon className={`w-6 h-6 ${selected ? 'stroke-black' : 'stroke-gray-icon group-hover:stroke-black'}`} />
    )
  },
  {
    key: 'Timeline',
    label: 'Timeline',
    icon: (selected: any) => (
      <ViewTimelineOutlinedIcon
        className={`w-6 h-6 ${selected ? 'stroke-black' : 'fill-gray-icon group-hover:stroke-black'}`}
      />
    )
  }
];
